export default {
  filterPlaceholder: 'Nach Status filtern',
  confirmDelete: 'Das Löschen des Status von "{filePathId}" löscht die Logdatei selbst nicht. Die nächste Erkennungsrunde findet sie erneut und importiert sie neu. Fortfahren?',
  resetSelected: 'Auswahl zurücksetzen ({count})',
  confirmBulkDelete: 'Das Löschen des Status von {count} Logdateien löscht die Logdateien selbst nicht. Die nächste Erkennungsrunde findet sie erneut und importiert sie neu. Fortfahren?',
};
